<h2>Campaign Setup</h2>
<p>Your brand has now been customised but you still need to set up a campaign in order to accept donations.</p>
<p>Would you like to do this now?</p>

<div *nzModalFooter>
  <button class="btn btn-light-primary btn-sm me-2" (click)="destroyModal()">No</button>
  <button
    type="button"
    (click)="confirm()"
    id="qrpay_sign_up_submit"
    class="btn btn-sm btn-theme"
  >
    Yes
  </button>
</div>
